// Third Party
import React, { ReactNode } from 'react';
import classNames from 'classnames';

// Components
import { ErrorTooltip } from '../tooltips';
import ThemeMode from '@/types/theme-mode';

export interface ButtonProps {
  'aria-label'?: string;
  children?: ReactNode;
  className?: string;
  icon?: string;
  disabled?: boolean;
  compact?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  type?: 'button' | 'submit' | 'reset';
  dark?: boolean;
  theme?: ThemeMode;
  noBackground?: boolean;
  darkerHover?: boolean;
  active?: boolean;
  invert?: boolean;
  error?: string;
  loading?: boolean;
  'data-testid'?: string;
  tabIndex?: number;
  role?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      icon,
      children,
      disabled,
      compact,
      darkerHover,
      dark,
      theme,
      onClick,
      noBackground,
      active,
      invert,
      error,
      loading,
      type = 'button',
      tabIndex,
      ...rest
    },
    ref,
  ) => {
    const classes = classNames(
      className,
      'button',
      { disabled, compact, dark, [`${theme}`]: theme, active, invert, loading },
      {
        'no-bg': noBackground,
        'darker-hover': darkerHover,
      },
    );

    return (
      <button {...rest} type={type} onClick={disabled ? undefined : onClick} className={classes} disabled={disabled || loading} ref={ref} tabIndex={tabIndex}>
        <div className="main-action-container d-flex align-items-center justify-content-center">
          {icon && !loading && <i className={`icon-${icon}`} aria-hidden="true" />}
          {loading && <i className="icon-spinner" />}

          {children}

          {error && <ErrorTooltip message={error} />}
        </div>
      </button>
    );
  },
);

export default Button;
